import src from "IMAGE";
export default { src, width: 1134, height: 168, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJElEQVR42mPYtGlTzsaNG/NAeNasWR5LliwJA7HXrFmTDqRjAUI4EznDmLwwAAAAAElFTkSuQmCC"};
